import React from 'react';

import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { SECTIONS_CONTENT } from './consts';
import { AboutSection } from './section';

interface AboutProps {}

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    maxWidth: 1030,
    margin: '0 auto',
    paddingTop: theme.spacing(18),
  },
}));

export const About = (props: AboutProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Grid container spacing={{ xs: 4, sm: 6 }}>
          {SECTIONS_CONTENT.map((i) => {
            return (
              <Grid item key={i.title} mb={20}>
                <AboutSection
                  title={i.title}
                  text={i.text}
                  img={i.img}
                  isReversed={i.isReversed}
                  subtitle={i.subtitle}
                  bullets={i.bullets}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};
